<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'usuarios-ponto-apoio',
  data () {
    return {
      title: 'Usuários Ponto Apoio'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/usuarios-ponto-apoio' || this.$router.currentRoute.path === '/usuarios-ponto-apoio/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/usuarios-ponto-apoio/index.vue